const ROLE_LABELS: Record<string, string> = {
  LaboratoryLevel: "Facility Level",
  CountryLevel: "Country Level",
  RegionLevel: "Region Level",
  ZoneLevel: "Zone Level",
  WoredaLevel: "Woreda Level",
  HubLevel: "Hub Level",
  ViewOnlyLevel: "View Only",
  SuperAdmin: "Super Admin",
  RedCross: "Red Cross",
};

function normalizeText(value: unknown): string {
  return value == null ? "" : String(value).trim();
}

function dedupeSegments(segments: string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const segment of segments) {
    const normalized = segment.toLowerCase();
    if (seen.has(normalized)) {
      continue;
    }
    seen.add(normalized);
    result.push(segment);
  }
  return result;
}

export function resolveUserDisplayName(user: any, fallback = "User"): string {
  const firstName = normalizeText(user?.firstName ?? user?.FirstName);
  const lastName = normalizeText(user?.lastName ?? user?.LastName);
  const fullName = `${firstName} ${lastName}`.trim();
  if (fullName) {
    return fullName;
  }

  const accountName = normalizeText(
    user?.userName ?? user?.UserName ?? user?.email ?? user?.Email
  );
  return accountName || fallback;
}

export function resolveUserFacilityName(user: any): string {
  const candidates = [
    user?.laboratory?.name,
    user?.hub?.name,
    user?.woreda?.name,
    user?.zone?.name,
    user?.region?.name,
    user?.facility?.name,
    user?.facilityName,
    user?.FacilityName,
    user?.laboratoryName,
    user?.LaboratoryName,
  ];
  for (const candidate of candidates) {
    const value = normalizeText(candidate);
    if (value) {
      return value;
    }
  }
  return "";
}

export function resolveUserRoleLabel(user: any): string {
  const roles: string[] = Array.isArray(user?.userRoles) ? user.userRoles : [];
  const primaryRole = normalizeText(roles[0] ?? user?.role ?? user?.roleName);
  if (!primaryRole) {
    return "";
  }
  if (ROLE_LABELS[primaryRole]) {
    return ROLE_LABELS[primaryRole];
  }
  return primaryRole.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
}

export function buildUserIdentitySummary(user: any, fallbackName = "User"): string {
  const segments = [
    resolveUserDisplayName(user, fallbackName),
    resolveUserFacilityName(user),
    resolveUserRoleLabel(user),
  ]
    .map((segment) => normalizeText(segment))
    .filter((segment) => segment.length > 0);

  return dedupeSegments(segments).join(" • ");
}
